module.exports = __webpack_public_path__ + "static/media/rightOutlined.4b6af1d9.svg";